<template>
  <div class="legal-page">
    <div class="container">
      <h1>About Us</h1>
      
      <section>
        <h2>Our Mission</h2>
        <p>At L2L.fun (Live to Learn), our mission is to make learning engaging, interactive, and accessible to everyone. We believe that the best way to learn is through play, exploration, and challenge.</p>
        <p>We create educational games that bridge the gap between entertainment and education, covering topics from vocabulary and mathematics to complex scientific concepts like quantum mechanics.</p>
      </section>

      <section>
        <h2>What We Do</h2>
        <p>We develop a variety of browser-based games designed to exercise your brain and teach new skills:</p>
        <ul>
          <li><strong>Quantum Go:</strong> An innovative strategy game that introduces players to the principles of quantum mechanics through the classic game of Go.</li>
          <li><strong>Mission Snake:</strong> A vocabulary-building game that combines arcade action with language learning.</li>
          <li><strong>Evolute 2048:</strong> A twist on the classic 2048 puzzle that teaches biological classification and evolution.</li>
          <li><strong>Math Tetris:</strong> A puzzle game that challenges your arithmetic skills under pressure.</li>
        </ul>
      </section>

      <section>
        <h2>Our Values</h2>
        <ul>
          <li><strong>Curiosity:</strong> We believe in the power of asking "why" and "how".</li>
          <li><strong>Innovation:</strong> We constantly seek new ways to visualize and interact with knowledge.</li>
          <li><strong>Accessibility:</strong> Education should be free and available to anyone with an internet connection.</li>
        </ul>
      </section>
      
      <div class="back-link">
        <router-link to="/">← Back to Home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style scoped>
/* Reusing styles from PrivacyPolicy for consistency */
.legal-page {
  padding: 40px 20px;
  color: #fff;
  min-height: 80vh;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

h1 {
  font-size: 2.5rem;
  margin-bottom: 30px;
  color: #fff;
}

section {
  margin-bottom: 30px;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #e0eaff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 10px;
}

p, li {
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 10px;
}

ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

.back-link {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.back-link a {
  display: inline-block;
  padding: 10px 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: white;
  text-decoration: none;
  transition: background 0.3s;
}

.back-link a:hover {
  background: rgba(255, 255, 255, 0.2);
}
</style>
